<template>
  <div class="main">

    <div class="box">
      <el-row v-if="pageState===0">
        <div style="display: grid; place-items: center;">
        <img class="pic-404__parent" src="@/assets/404_images/loading.gif" alt="logd">
        </div>
      </el-row>
      <el-row v-if="pageState===9" :gutter="10">
        <el-col :span="4">
          <el-card class="box-card">
            <div slot="header"
                 class="clearfix">
                 <el-select v-model="OrderListParams.country" default-first-option placeholder="Select" @change="countryChangeEvent" size="mini" style="width:70px;margin-right:10px">
                        <el-option label="US" value="US"></el-option>
                        <el-option label="EU" value="EU"></el-option>
                        <el-option label="GB" value="GB"></el-option>
                        <el-option label="AU" value="AU"></el-option>
                      </el-select>
              <span>Record of this call</span>
              
            </div>
            <el-form ref="recordForm"
                     :model="Recordform"
                     label-width="100px">
              <el-input v-model="Recordform.phoneNumber"
                        style="margin-bottom: 10px;"
                        placeholder="Phone Number"
                        disabled></el-input>
              <el-input v-model="Recordform.customerName"
                        style="margin-bottom: 10px;"
                        placeholder="Customer Name"
                        clearable>
              </el-input>
              <el-input v-model="Recordform.customerPhone"
                        style="margin-bottom: 10px;"
                        placeholder="Common telephone number"
                        clearable></el-input>
              <el-radio-group v-model="Recordform.consultType"
                              style="margin-bottom: 10px;"
                              @change="changeConsultType">
                <el-radio :label="1">Pre-sale</el-radio>
                <el-radio :label="2">After-sale</el-radio>
              </el-radio-group>

              <el-select v-model="Recordform.consult"
                         style="margin-bottom: 10px;width:100%"
                         clearable
                         placeholder="Consult Item">
                <el-option v-for="item in ConsultItem"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-switch v-model="Recordform.completedFlag" active-text="Done" inactive-text="Undone" style="margin-bottom: 10px;" />
              <el-input type="textarea"
                        rows="10"
                        maxlength="2000"
                        show-word-limit
                        style="margin-bottom: 10px;width:100%"
                        placeholder="Recording"
                        v-model="Recordform.recording"></el-input>

              <el-button type="primary"
                         @click="submitRecord" size="mini">submit</el-button>

            </el-form>
          </el-card>
          <el-card class="box-card">
            <div slot="header"
                 class="clearfix">
              <span>History recording({{ TimeZoneName }})</span>
            </div>
            <el-card v-for="(item,index) in RecordingList"
                     :key="index">
                     <div slot="header" class="clearfix">
                      <b style="font-size:12px;"> {{item.createName}}</b>
                      <i v-if="!item.completedFlag" class="el-icon-s-flag" style="color:red" />
                      <small style="float: right;font-size:12px;"> {{item.displayTime}}</small>
                      
                  </div>
              <div v-html="item.recordingHtml" />

            </el-card>
          </el-card>
        </el-col>
        <el-col :span="20">
          <el-tabs type="border-card"
                   v-model="activeName">
            <el-tab-pane label="Order Information"
                         name="order">
              <el-card class="box-card">

                <el-form :inline="true"
                         :model="OrderListParams"
                         size="mini"
                         label-width="80px">
                  <el-form-item>
                      <el-select v-model="OrderListParams.storeName" placeholder="Store" clearable filterable>
                          <el-option v-for="i in AuthStoreOptions" :value="i.value" :label="i.label" :key="i.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="OrderListParams.orderId" placeholder="OrderId" clearable @keyup.enter.native="queryOrderList"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="OrderListParams.customId" placeholder="CustomerId" clearable @keyup.enter.native="queryOrderList"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="OrderListParams.customName" placeholder="CustomerName" clearable @keyup.enter.native="queryOrderList"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="OrderListParams.email" placeholder="Email" clearable @keyup.enter.native="queryOrderList"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="OrderListParams.trackNo" placeholder="TrackingNo" clearable @keyup.enter.native="queryOrderList"/>
                  </el-form-item>
                  
                  <el-form-item>
                    <el-input v-model="OrderListParams.phone" placeholder="Phone" clearable @keyup.enter.native="queryOrderList"/>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="OrderListParams.sku" placeholder="Sku" clearable @keyup.enter.native="queryOrderList"/>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary"
                               @click="queryOrderList">Search</el-button>
                  </el-form-item>
                </el-form>

                <el-table ref="orderTable" v-loading="loading" :data="OrderListData" height="300" size="mini" style="width: 100%" highlight-current-row @row-click="selectOrderData">
                  <el-table-column type="index" fixed="left" align="center" label="No"> </el-table-column>
                    <el-table-column prop="orderType" fixed="left" align="center" :show-overflow-tooltip="true" width="90" label="Type">
                        <template slot-scope="scope">
                            <span v-if="scope.row.orderType===0">Normal</span>
                            <el-tag v-else-if="scope.row.orderType===1" effect="dark" size="small" type="danger">Return</el-tag>
                            <el-tag v-else-if="scope.row.orderType===2" effect="dark" size="small" type="warning">Resend</el-tag>
                            <el-tag v-else-if="scope.row.orderType===3" effect="dark" size="small" type="warning">Resend</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" fixed="left" align="center" :show-overflow-tooltip="true" width="100" label="Status">
                        <template slot-scope="scope">
                            <span v-if="scope.row.state===0">Normal</span>
                            <el-tag v-else-if="scope.row.state===6" effect="dark" size="small" type="info">Cancel</el-tag>
                            <el-tag v-else effect="dark" size="small" type="danger">Abnormal</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="orderId" fixed="left" align="left" :show-overflow-tooltip="true" width="160" label="OrderId">
                    </el-table-column>
                    <el-table-column prop="dianPu" align="left" :show-overflow-tooltip="true" width="100" label="Store"> </el-table-column>
                    <el-table-column prop="orderDate" align="left" :show-overflow-tooltip="true" width="110" label="OrderDate" :formatter="formatDate"></el-table-column>
                    <el-table-column prop="trackNo" align="left" :show-overflow-tooltip="true" width="250" label="TrackNo"></el-table-column>
                    <el-table-column prop="cpbh" align="left" :show-overflow-tooltip="true" width="180" label="Item"></el-table-column>
                    <el-table-column prop="khName" align="left" :show-overflow-tooltip="true" width="150" label="Customer"></el-table-column>
                    <el-table-column prop="trackingStatus" align="left" :show-overflow-tooltip="true" width="100" label="Tracking"></el-table-column>
                    <el-table-column prop="phone" align="left" :show-overflow-tooltip="true" width="140" label="Phone"></el-table-column>
                    <el-table-column prop="fkzh" align="left" :show-overflow-tooltip="true" width="150" label="CustomId"></el-table-column>
                    <el-table-column prop="recordNumber" align="left" :show-overflow-tooltip="true" width="125" label="RecordNumber"> </el-table-column>
                    <el-table-column prop="hthm" align="left" :show-overflow-tooltip="true" width="150" label="Hthm"></el-table-column>
                    <el-table-column prop="fullAddress" align="left" :show-overflow-tooltip="true" width="250" label="Address"></el-table-column>
                </el-table>
                <el-pagination @size-change="handleOrderSizeChange"
                               @current-change="handleOrderSizeChange"
                               :current-page.sync="OrderListParams.pageIndex"
                               :page-sizes="[5, 10, 20, 50]"
                               :page-size.sync="OrderListParams.pageSize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="OrderListParams.totalCount">
                </el-pagination>
              </el-card>
              <el-tabs type="border-card">
                  <el-tab-pane label="Order details">
                    <el-row>
                        <el-descriptions :column="4" border size="medium" :label-style="labelWidth">
                            <el-descriptions-item label="OrderId">
                                {{OrderInfoModel.OrderForm.orderId}}
                            </el-descriptions-item>
                            <el-descriptions-item label="OrderDate">
                                {{OrderInfoModel.OrderForm.orderDate}}
                            </el-descriptions-item>
                            <el-descriptions-item label="TotalPrice">
                                <div style="font-weight:bolder;float:right"> {{OrderInfoModel.OrderForm.totalAmount}}<el-tag v-if="OrderInfoModel.OrderForm.currency" effect="dark" size="mini" style="margin-left:10px">{{OrderInfoModel.OrderForm.currency}}</el-tag> </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="Platform">
                                {{OrderInfoModel.OrderForm.xspt}}
                            </el-descriptions-item>
                            <el-descriptions-item label="Store">
                                {{OrderInfoModel.OrderForm.dianPu}}
                            </el-descriptions-item>
                            <el-descriptions-item label="Country">
                                {{OrderInfoModel.OrderForm.temp10}}
                            </el-descriptions-item>
                            <el-descriptions-item label="Customer">
                                {{OrderInfoModel.OrderForm.khName}}
                            </el-descriptions-item>
                            <el-descriptions-item label="Phone">
                                {{OrderInfoModel.OrderForm.phone}}
                            </el-descriptions-item>
                            <el-descriptions-item :span="2" label="Address">
                                {{OrderInfoModel.OrderForm.fullAddress}}
                            </el-descriptions-item>
                            <el-descriptions-item label="Email">
                                {{OrderInfoModel.OrderForm.email}}
                            </el-descriptions-item>
                            <el-descriptions-item v-if="OrderInfoModel.OrderForm.amazonPhone" label="AM Phone">
                                {{OrderInfoModel.OrderForm.amazonPhone}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-row>
                    <el-row style="margin-top:10px">
                        <el-table ref="orderSheetTable" size="mini" :data="OrderInfoModel.OrderForm.sheets" row-key="number" stripe border :height="160" >
                            <el-table-column align="center" label="Image" width="100">
                                <template slot-scope="scope">
                                    <el-image style="width: 60px; height: 60px;margin-left:3px"
                                              :src="scope.row.imageUrl"
                                              :preview-src-list="[scope.row.imageUrl]">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column  align="center" :show-overflow-tooltip="true" width="100" label="Tags"> 
                              <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.tagText" placement="top" effect="light" :disabled="scope.row.tagItems.length<2">
                                  <div slot="content">
                                    <p v-for="(item,i) in scope.row.tagItems" :key="i">{{item}}</p>
                                  </div>
                                  <el-tag size="mini" effect="dark">{{scope.row.tagText}}</el-tag>
                                </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku" align="center" :show-overflow-tooltip="true" width="120" label="Sku"> </el-table-column>
                            <el-table-column prop="cpbh" align="center" :show-overflow-tooltip="true" width="120" label="Item No"> </el-table-column>
                            <el-table-column prop="sl" align="center" :show-overflow-tooltip="true" width="60" label="Qty"> </el-table-column>
                            <el-table-column prop="zje" align="center" :show-overflow-tooltip="true" width="100" label="Item price"> </el-table-column>
                            <el-table-column prop="salesTaxState" align="center" :show-overflow-tooltip="true" width="80" label="Tax"> </el-table-column>
                            <el-table-column prop="otherCharge" align="center" :show-overflow-tooltip="true" width="120" label="Other charge"></el-table-column>
                            <el-table-column prop="fee" align="left" :show-overflow-tooltip="true" width="80" label="Shipping"> </el-table-column>
                            <el-table-column prop="cpgg" align="left" :show-overflow-tooltip="true" label="Specifications"> </el-table-column>
                        </el-table>

                    </el-row>

                  </el-tab-pane>
                  <el-tab-pane label="Memo"> 
                     <span slot="label" :style="MemoTabPaneStyle">{{MemoTabPaneTitle}}</span>
                    <el-row type="flex" justify="space-between">
                        <el-col :span="1">
                            <el-button v-if="OrderInfoModel.OrderForm.number!==0" type="primary" size="mini" icon="el-icon-chat-line-square" @click="ShowMemoForm('Add')">New memo</el-button>
                        </el-col>
                        <el-col :span="16">
                            <el-descriptions :column="4" size="mini" border :label-style="{'width':'60px'}">
                                <el-descriptions-item label="PS">
                                    <span style="color:red;font-weight:bold">{{OrderInfoModel.MemoNote}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="Type">
                                    {{OrderInfoModel.MemoContentTypeText}}
                                </el-descriptions-item>
                                <el-descriptions-item label="Phone">
                                    {{OrderInfoModel.MemoPhone}}
                                </el-descriptions-item>
                                <el-descriptions-item label="Email">
                                    {{OrderInfoModel.MemoEmail}}
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-col>
                    </el-row>
                    <el-table ref="TF_Memo" v-loading="OrderInfoModel.MemoLoading" size="medium" :data="OrderInfoModel.MemoList" row-key="id" stripe border height="300px" @row-dblclick="showMemoInfo">
                            <el-table-column type="index" fixed="left" align="center" label="#"> </el-table-column>
                            <el-table-column prop="createTime" align="center" :show-overflow-tooltip="true" width="160" label="Date"> </el-table-column>
                            <el-table-column prop="userName" align="left" :show-overflow-tooltip="true" width="120" label="From"></el-table-column>
                             <el-table-column prop="memoType" align="center" :show-overflow-tooltip="true" width="110" label="Type">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.memoType==2" type="danger" size="mini" effect="dark">Response</el-tag>
                                    <el-tag v-else-if="scope.row.memoType==3" type="primary" size="mini" effect="dark">Draft</el-tag>
                                    <el-tag v-else type="info" size="mini">No response</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="memo" align="left" label="Memo">
                              <template slot-scope="scope">
                                <div class="pre" v-html="scope.row.memo" />
                              </template>
                            </el-table-column>
                            <el-table-column align="left" :show-overflow-tooltip="true" width="200" label="Image">
                                <template slot-scope="scope">
                                    <div v-if="!!scope.row.files">
                                        <el-image v-for="(item,i) in scope.row.files" style="width: 40px; height: 50px;margin-right:10px;cursor: pointer"
                                                  :src="item.iconUrl"
                                                  :key="i"
                                                  :preview-src-list="scope.row.imageUrlList"
                                                  @click="item.isImage?'':ShowBigImage(item.downloadUrl)">
                                        </el-image>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Option" align="center" width="120" fixed="right">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.editFlag" @click="ShowMemoForm('Edit',scope.row)" type="primary" size="mini" icon="el-icon-edit" circle></el-button>
                                    <el-popconfirm v-if="scope.row.editFlag" @confirm="doDeleteMemo(scope.row)" title="Are you sure to delete this data?" style="margin-left:10px">
                                        <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                                    </el-popconfirm>
                                </template>

                            </el-table-column>
                        </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="Tracking" name="third">
                    <el-row>
                        <el-col :span="8">
                            <div style="font-size:10px;">
                                <el-descriptions :column="1" size="small" border :label-style="labelWidthTracking">
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-truck"></i>
                                            Logistics type
                                        </template>
                                        {{OrderInfoModel.TrackingForm.type}}
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="OrderInfoModel.TrackingForm.specialType===2">
                                        <template slot="label">
                                            <i class="el-icon-truck"></i>
                                            Truck company
                                        </template>
                                        {{OrderInfoModel.TrackingForm.truckCompany}}
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="OrderInfoModel.TrackingForm.specialType===2">
                                        <template slot="label">
                                            <i class="el-icon-truck"></i>
                                            BOL number
                                        </template>
                                        {{OrderInfoModel.TrackingForm.bolNumber}}
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="OrderInfoModel.TrackingForm.specialType===2">
                                        <template slot="label">
                                            <i class="el-icon-truck"></i>
                                            Pro number
                                        </template>
                                        {{OrderInfoModel.TrackingForm.proNumber}}
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="OrderInfoModel.TrackingForm.specialType===2">
                                        <template slot="label">
                                            <i class="el-icon-truck"></i>
                                            Freight charge
                                        </template>
                                        {{OrderInfoModel.TrackingForm.truckFreight}}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-guide"></i>
                                            Tracking no
                                        </template>
                                        {{OrderInfoModel.TrackingForm.trackNo}}
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="OrderInfoModel.TrackingForm.returnTrackNo">
                                        <template slot="label">
                                            <i class="el-icon-guide"></i>
                                            ReturnTrackNo
                                        </template>
                                        {{OrderInfoModel.TrackingForm.returnTrackNo}}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-wind-power"></i>
                                            Tracking status
                                        </template>
                                        <el-tag v-if="OrderInfoModel.TrackingForm.processCode==8" effect="dark" size="mini" type="info">{{OrderInfoModel.TrackingForm.des}}</el-tag>
                                        <el-tag v-else-if="OrderInfoModel.TrackingForm.processCode==30" effect="dark" size="mini" type="warning">{{OrderInfoModel.TrackingForm.des}}</el-tag>
                                        <el-tag v-else-if="OrderInfoModel.TrackingForm.processCode==50" effect="dark" size="mini">{{OrderInfoModel.TrackingForm.des}}</el-tag>
                                        <el-tag v-else-if="OrderInfoModel.TrackingForm.processCode==100" effect="dark" size="mini" type="success">{{OrderInfoModel.TrackingForm.des}}</el-tag>
                                        <el-tag v-else-if="OrderInfoModel.TrackingForm.processCode==200" effect="dark" size="mini" type="danger">{{OrderInfoModel.TrackingForm.des}}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-s-home"></i>
                                            Warehouse
                                        </template>
                                        {{OrderInfoModel.TrackingForm.warehouse}}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-collection-tag"></i>
                                            Shipping status
                                        </template>
                                        {{OrderInfoModel.TrackingForm.wmsShippingStatus}}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-date"></i>
                                            Picked time
                                        </template>
                                        {{OrderInfoModel.TrackingForm.wmsPickDate}}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-date"></i>
                                            OriginScan time
                                        </template>
                                        {{OrderInfoModel.TrackingForm.pickupDate}}
                                    </el-descriptions-item>

                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-date"></i>
                                            Delivered time
                                        </template>
                                        {{OrderInfoModel.TrackingForm.deliveredDate}}
                                    </el-descriptions-item>
                                    <el-descriptions-item v-if="OrderInfoModel.TrackingForm.specialType===1">
                                        <template slot="label">
                                            <i class="el-icon-picture"></i>
                                            Delivered image
                                        </template>
                                        <el-image v-for="(item,i) in OrderInfoModel.TrackingForm.deliveredImageUrls" style="width: 100px; height: 100px;margin-left:10px"
                                                  :key="i"
                                                  :src="item"
                                                  :preview-src-list="OrderInfoModel.TrackingForm.deliveredImageUrls">
                                            <div slot="error" class="img_error">
                                                Image<br />Error
                                            </div>
                                        </el-image>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </div>

                        </el-col>
                        <el-col :span="16">
                            <div style="height:40vh;overflow-y:auto">
                                <el-timeline :reverse="true">
                                    <el-timeline-item v-for="(activity, index) in OrderInfoModel.TrackingForm.nodeList"
                                                      :key="index"
                                                      :color="activity.color"
                                                      placement="top"
                                                      :timestamp="activity.nodeTime">
                                        <h4>{{activity.nodeDes}}</h4>
                                        <p> {{activity.trackDetail}}</p>
                                    </el-timeline-item>
                                </el-timeline>

                            </div>

                        </el-col>
                    </el-row>

                  </el-tab-pane>
                  <el-tab-pane label="ChangeAddress" name="four">
                    <el-row style="margin-bottom:10px">
                        <el-button v-if="IsModifiable" type="primary" size="mini" icon="el-icon-map-location" @click="doOpenAddrDialog('Add')">Add</el-button>
                        <el-tag v-else size="mini" type="info" effect="dark">Only normal orders and logistics undelivered are supported</el-tag>
                    </el-row>
                    <el-table size="mini" :data="ChangeAddrLogList" row-key="Id" stripe border height="300px">
                        <el-table-column type="index" fixed="left" align="center" label="#"> </el-table-column>
                        <el-table-column prop="createTime" align="center" :show-overflow-tooltip="true" width="160" label="Date"> </el-table-column>
                        <el-table-column prop="origAddress" align="left" label="OrigAddress" show-overflow-tooltip width="200"> </el-table-column>
                        <el-table-column prop="fullAddress" align="left" label="NewAddress" show-overflow-tooltip min-width="200"> </el-table-column>
                        <el-table-column prop="logisticsType" align="center" label="Logistics" show-overflow-tooltip width="100"> </el-table-column>
                        <el-table-column align="center" :show-overflow-tooltip="true" width="130" label="Charge type">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.changeAddrType===1" size="mini" effect="dark" type="success">For Free</el-tag>
                                <el-tag v-else size="mini" effect="dark" type="danger">Have to charge</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :show-overflow-tooltip="true" width="130" label="Confirm Address">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.modifyStatus==1" size="mini" effect="dark" type="success">Modified</el-tag>
                                <el-tooltip v-else-if="scope.row.modifyStatus===2" :content="scope.row.Notes" placement="bottom" effect="light">
                                    <el-tag size="mini" effect="dark" type="info">No need</el-tag>
                                </el-tooltip>
                                <el-tag v-else size="mini" effect="dark" type="danger">None</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :show-overflow-tooltip="true" width="120" label="Collect fees">
                            <template slot-scope="scope">
                                {{scope.row.commissionAmount}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :show-overflow-tooltip="true" width="120" label="Payment">
                            <template slot-scope="scope">
                                <span v-if="scope.row.actualAmount>0"> {{scope.row.actualAmount}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :show-overflow-tooltip="true" width="80" label="Currency">
                            <template slot-scope="scope">
                                <el-tag v-if="!!scope.row.currency" size="mini" effect="dark" type="success">{{scope.row.currency}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createName" align="left" :show-overflow-tooltip="true" width="120" label="Operator"></el-table-column>

                    </el-table>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="Product Search"
                         name="product">

              <el-card class="box-card">
                <el-form :inline="true"
                         :model="ProductSearchParams"
                         size="mini">
                  <el-form-item>
                    <el-input v-model="ProductSearchParams.cpbh"
                              placeholder="Product no" clearable @keyup.enter.native="handleQueryProduct"></el-input>
                  </el-form-item>
                  <el-form-item>
                        <el-cascader v-model="ProductSearchParams.tags"
                                     :props="{value:'value',label:'labelEn',children:'children'}"
                                     :options="ProductTagOptions" style="width:100%" size="mini" clearable placeholder="Product tag" :show-all-levels="false"></el-cascader>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary"
                               @click="handleQueryProduct">Search</el-button>
                  </el-form-item>
                </el-form>

                <el-table ref="productTable"
                          v-loading="loading"
                          :data="ProductListData "
                          height="230"
                          size="mini"
                          highlight-current-row
                          style="width: 100%"
                          @row-click="selectProductData">
                  <el-table-column prop="cpbh" align="left" :show-overflow-tooltip="true" width="150" label="Product no"></el-table-column>
                  <el-table-column prop="ywpm" align="left" label="Product name"></el-table-column>
                  <el-table-column  align="center" :show-overflow-tooltip="true" width="100" label="Tags"> 
                    <template slot-scope="scope">
                      <el-tooltip v-if="scope.row.tagText" placement="top" effect="light" :disabled="scope.row.tagItems.length<2">
                        <div slot="content">
                          <p v-for="(item,i) in scope.row.tagItems" :key="i">{{item}}</p>
                        </div>
                        <el-tag size="mini" effect="dark">{{scope.row.tagText}}</el-tag>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="Image" width="140" align="center">
                      <template slot-scope="scope">
                        <el-image v-if="!!scope.row.url" style="width: 50px; height: 50px"
                                  :src="scope.row.url">
                            <div slot="error" class="img_error">
                                Error
                            </div>
                        </el-image>
                      </template>
                  </el-table-column>
                </el-table>
                <el-pagination @size-change="getProductList"
                               @current-change="getProductList"
                               :current-page.sync="ProductSearchParams.pageIndex"
                               :page-sizes="[5, 10, 20, 50]"
                               :page-size.sync="ProductSearchParams.pageSize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="ProductSearchParams.totalCount">
                </el-pagination>
              </el-card>
                <el-tabs type="border-card">
                  <el-tab-pane label="Pruduct">
                    <el-descriptions :column="3" border size="medium" :label-style="labelWidth">
                        <el-descriptions-item label="Size">
                            {{ProductInfoModel.ProductForm.sizeInch}} <el-tag type="info" size="small" effect="dark" style="float:right">inch</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="Gross weight">
                            {{ProductInfoModel.ProductForm.grossWeightLbs}}<el-tag type="info" size="small" effect="dark" style="float:right">lbs</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="Net weight">
                            {{ProductInfoModel.ProductForm.netWeightLbs}}<el-tag  type="info" size="small" effect="dark" style="float:right">lbs</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="Description" :span="3">
                            {{ProductInfoModel.ProductForm.ywms}}
                        </el-descriptions-item>
                        <el-descriptions-item label="Installation video">
                            <div v-if="ProductInfoModel.VideoUrl!=''">
                                <el-image :src="ProductInfoModel.VideoUrl">
                                    <div slot="error" class="img_error">
                                        Error
                                    </div>
                                </el-image>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                  <el-tab-pane label="Photo">
                    <el-image v-for="(item,index) in ProductInfoModel.PhotoList"
                              :key="index"
                              style="width: 100px; height: 100px;margin-right:10px"
                              :src="item"
                              :preview-src-list="ProductInfoModel.PhotoList">
                    </el-image>
                  </el-tab-pane>
                  <el-tab-pane label="Instructions">
                    <el-table ref="instructionsTable" :data="ProductInfoModel.InstructionsList" stripe
                              style="width: 100%" height="40vh" size="small">
                        <el-table-column prop="fileName" label="File name" width="250">
                        </el-table-column>
                        <el-table-column prop="createTime" label="Date" width="200">
                        </el-table-column>
                        <el-table-column label="Files" min-width="200">
                            <template slot-scope="scope">
                                <a :href="scope.row.downloadUrl" target="_blank" style="cursor:pointer;text-align:center">
                                    <el-image v-if="scope.row.iconUrl !==''" style="width: 40px; height: 50px"
                                              :src="scope.row.iconUrl">
                                    </el-image>
                                </a>
                            </template>
                        </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="Picking list">
                    <el-table ref="pickingListTable" :data="ProductInfoModel.PickingList" stripe 
                              style="width: 100%" height="40vh" size="small">
                        <el-table-column prop="fileName" label="File name" width="250">
                        </el-table-column>
                        <el-table-column prop="createTime" label="Date" width="200">
                        </el-table-column>
                        <el-table-column label="Files" min-width="200">
                            <template slot-scope="scope">
                                <a :href="scope.row.downloadUrl" target="_blank" style="cursor:pointer;text-align:center">
                                    <el-image v-if="scope.row.iconUrl !==''" style="width: 40px; height: 50px"
                                              :src="scope.row.iconUrl">
                                    </el-image>
                                </a>
                            </template>
                        </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="Parts">
                    <el-table :data="ProductInfoModel.PartsList"
                              height="40vh"
                              size="small"
                              style="width: 100%">
                      <el-table-column prop="url" label="Image" width="200" align="center">
                            <template slot-scope="scope">
                                <el-image v-if="scope.row.url !==''" style="width: 50px; height: 50px"
                                          :src="scope.row.url"
                                          :preview-src-list="ProductInfoModel.PartsImageList">
                                    <div slot="error" class="img_error">

                                    </div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pjbh" label="Parts no" width="250">
                        </el-table-column>
                        <el-table-column prop="ywpm" label="Parts name">
                        </el-table-column>
                    </el-table>
                  </el-tab-pane>

                  <el-tab-pane label="FAQ">
                    <el-table :data="ProductInfoModel.FAQList"
                              height="40vh"
                              size="small"
                              style="width: 100%">
                      <el-table-column prop="sku" label="Sku" width="150">
                        <template slot-scope="scope">
                          <el-tag v-if="scope.row.replaceItemFlag" size="mini" type="success" effect="dark">R</el-tag>
                          {{scope.row.sku}}
                        </template>
                      </el-table-column>
                        <el-table-column prop="questionEN" label="Question" min-width="400"></el-table-column>
                        <el-table-column prop="answerEN" label="Answer" min-width="400"></el-table-column>
                        <el-table-column label="Files" width="200">
                            <template slot-scope="scope">
                                <a v-for="(item,i) in scope.row.files" :key="i" :href="item.downloadUrl" target="_blank">
                                    <el-image style="width: 40px; height: 50px;margin-right:10px"
                                              :src="item.iconUrl">
                                    </el-image>
                                </a>
                            </template>
                        </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-row v-if="pageState===-1">
        <div style="display: grid; place-items: center;">
        <img class="pic-404__parent" src="@/assets/404_images/404.png" alt="404">
        </div>
      </el-row>
    </div>
    

    <el-dialog :title="OrderInfoModel.MemoType" top ="5vh" width="75%" :visible.sync="OrderInfoModel.DialogMemoVisible" :before-close="handleClose">

        <el-form ref="MemoForm" :model="OrderInfoModel.MemoForm" label-width="80px" size="mini" :rules="memoRules">
            <el-row v-if="OrderInfoModel.MemoType=='View'">
                <el-col :span="12">
                    <el-form-item label="Date">
                        <el-input v-model="OrderInfoModel.MemoForm.createTime" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="From">
                        <el-input v-model="OrderInfoModel.MemoForm.userName" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
              <el-form-item label="PreMemo" v-if="OrderInfoModel.MemoForm.preMemo">
                <el-table ref="PreMemoTable" v-loading="OrderInfoModel.MemoLoading" size="mini" :data="OrderInfoModel.MemoList" row-key="id" stripe border height="300px">
                            <el-table-column type="index" fixed="left" align="center" label="#"> </el-table-column>
                            <el-table-column prop="createTime" align="center" :show-overflow-tooltip="true" width="160" label="Date"> </el-table-column>
                            <el-table-column prop="userName" align="left" :show-overflow-tooltip="true" width="120" label="From"></el-table-column>
                            <el-table-column prop="memo" align="left" label="Memo">
                              <template slot-scope="scope">
                                <div class="pre" v-html="scope.row.memo" />
                              </template>
                            </el-table-column>
                            <el-table-column align="left" :show-overflow-tooltip="true" width="200" label="Image">
                                <template slot-scope="scope">
                                    <div v-if="!!scope.row.files">
                                        <el-image v-for="(item,i) in scope.row.files" style="width: 40px; height: 50px;margin-right:10px;cursor: pointer"
                                                  :src="item.iconUrl"
                                                  :key="i"
                                                  :preview-src-list="scope.row.imageUrlList"
                                                  @click="item.isImage?'':ShowBigImage(item.downloadUrl)">
                                        </el-image>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
            </el-form-item>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="Type">
                        <el-select v-model="OrderInfoModel.MemoForm.memoType" :disabled="OrderInfoModel.MemoType !=='Add'">
                            <el-option v-for="i in MemoTypeOptions"
                                       :value="i.value" :label="i.label" :key="i.value">
                            </el-option>
                        </el-select>
                        <el-tooltip class="item" effect="light" placement="top">
                            <div slot="content">
                                <p>No response needed：Write your own memo without reminding the other party to reply,Can only be seen by oneself</p>
                                <p>Response required：Prompt the other party to view</p>
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Option" prop="contentType">
                        <el-select v-model="OrderInfoModel.MemoForm.contentType" :readonly="OrderInfoModel.MemoType==='View'">
                            <el-option v-for="i in contentTypeOptions"
                                       :value="i.value" :label="i.label" :key="i.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="Phone">
                        <el-input v-model="OrderInfoModel.MemoForm.phone"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Email">
                        <el-input v-model="OrderInfoModel.MemoForm.email"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-form-item label="Memo">
                <el-input type="textarea" v-model="OrderInfoModel.MemoForm.memo" rows="8" :readonly="OrderInfoModel.MemoType==='View'"></el-input>
            </el-form-item>

            <el-form-item label="Images" v-if="OrderInfoModel.MemoType!='View'">
                <el-upload action="https://crmapi.hooyagroup.com/api/order/UploadMemo"
                           list-type="picture-card"
                           :file-list="upfilelist"
                           :on-preview="handlePictureCardPreview"
                           :on-remove="handleRemove"
                           :on-change="handleRemove"
                           :auto-upload="true"
                           :on-error="handleError"
                           >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="Images" v-if="OrderInfoModel.MemoType=='View'&&OrderInfoModel.MemoForm.files&&OrderInfoModel.MemoForm.files.length>0">
                <el-image v-for="(item,i) in OrderInfoModel.MemoForm.files" style="width: 120px; height: 150px;margin-right: 10px;cursor: pointer"
                          :src="item.url"
                          :key="i"
                          @click="item.isImage?'':ShowBigImage(item.downloadUrl)"
                          :preview-src-list="OrderInfoModel.MemoForm.imageUrlList"
>
                </el-image>
            </el-form-item>
        </el-form>
        <div style="text-align:center;margin-top:10px">
            <el-button v-if="OrderInfoModel.MemoType=='Add'" type="primary" @click="SubmitMemoEvent" :loading="Saveing" size="mini">Submit</el-button>
            <el-button v-if="OrderInfoModel.MemoType=='Edit'" type="primary" @click="doUpdateMemo" :loading="Saveing" size="mini">Submit</el-button>
            <el-button v-if="OrderInfoModel.MemoType=='Edit' && OrderInfoModel.MemoForm.memoType==3" type="warning" @click="doDraftToFormal" :loading="ToFormalLoading" size="mini">ToFormal</el-button>
            <el-button v-if="OrderInfoModel.MemoType=='View'" type="warning" @click="replyEvent" size="mini">Reply</el-button>
        </div>
    </el-dialog>

    <el-dialog :title="`${OrderInfoModel.OrderForm.orderId}`" top="5vh" width="75%" :visible.sync="dialogAddrVisible">

        <el-form ref="AddrForm" :model="ChangeAddrForm" label-width="80px" size="mini">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Address">
                        <el-input v-model="ChangeAddrForm.address"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Address1">
                        <el-input v-model="ChangeAddrForm.address1"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="City">
                        <el-input v-model="ChangeAddrForm.city"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="States">
                        <el-input v-model="ChangeAddrForm.states"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Zipcode">
                        <el-input v-model="ChangeAddrForm.zipcode"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-descriptions :column="3" border size="mini" :label-style="{'width':'120px'}">
                    <el-descriptions-item label="OrderId">
                        {{ChangeAddrForm.orderId}}
                    </el-descriptions-item>
                    <el-descriptions-item label="Store">
                        {{ChangeAddrForm.store}}
                    </el-descriptions-item>
                    <el-descriptions-item label="OrderDate">
                        {{ChangeAddrForm.orderDate}}
                    </el-descriptions-item>
                    <el-descriptions-item label="Customer">
                        {{ChangeAddrForm.customer}}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="OrigAddress">
                        {{ChangeAddrForm.fullAddress}}
                    </el-descriptions-item>
                    <el-descriptions-item label="Charge type">
                        <el-tag v-if="ChangeAddrForm.changeAddrType===1" size="mini" effect="dark" type="success">For Free</el-tag>
                        <el-tag v-else size="mini" effect="dark" type="danger">Have to charge</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item v-if="ChangeAddrForm.changeAddrType==2" label="Logistics">
                        {{ChangeAddrForm.logisticsType}}
                    </el-descriptions-item>
                    <el-descriptions-item span="3" v-if="ChangeAddrForm.changeAddrType==2" label="Collect fees">
                        {{ChangeAddrForm.commissionAmount}} <el-tag style="float:right" size="mini" effect="dark" type="success">{{ChangeAddrForm.currency}}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item span="3" v-if="ChangeAddrForm.changeAddrType==2" label="BankInfo">
                        <p v-for="(item, index) in ChangeAddrForm.bandCardInfo"
                           :key="index">
                            {{item}}
                        </p>
                    </el-descriptions-item>
                </el-descriptions>
            </el-row>
        </el-form>
        <div style="text-align:center;margin-top:10px">
            <el-button type="primary" @click="doSubmitChangeAddr" :loading="Saveing" size="mini">Submit</el-button>
            <el-button @click="dialogAddrVisible=false" style="float:right; margin-right:10px" size="mini">Cancel</el-button>
        </div>
    </el-dialog>
  </div>
</template>


<script>

import { QueryOrder, GetMemoInfo,GetTracking,SubmitMemo,GetAuthStoreOptions,UpdateMemo,DeleteMemo,SubmitMemoDraftToFormal,GetProductLabelsAsNid,GetChangeAddrLog,GetTempChangeOrderAddrInfo,SubmitChangeAddr,GetChangeAddrModifiable } from '@/api/order'
import { queryRecording, autoSaveRecording } from '@/api/call'
import { verify,changeCountry } from '@/api/auth'
import store from '@/store/store'
import { QueryProduct, GetProductPhotoList, GetInstructions,GetPackingList, GetProductPartsList, GetProductFAQList,GetInstallationVideo,GetProductTagOptions,GetProductTags } from '@/api/product'
import {GetContentTypeOptions} from '@/api/memo'
import {GetOrderUniqueId} from '@/api/orderQuery'

export default {
  name: 'crm',
  data () {
    return {
      loading: false,
      pageState:0,
      dialogLoading: false,
      activeName: "order",
      Recordform: {
        customerName: undefined,
        phoneNumber: undefined,
        consultType: 0,
        recording: undefined,
        customerPhone: undefined,
        consult: 0
      },
      OrderListParams: {
        pageIndex: 0,
        pageSize: 5,
        totalCount: 0,
        totalPages: 1,
        orderBy: '',
        customName: '',
        trackNo: '',
        country: 'US',
        customId:'',
        phone:'',
        orderId:'',
        email:'',
        storeName:'',
        sku:''
      },
      OrderQueryType: 'Search',
      ProductSearchParams: {
        pageIndex: 0,
        pageSize: 5,
        totalCount: 0,
        totalPages: 1,
        cpbh: '',
        tags:[],
        tag:'',
      },
      ConsultItem: [
        { label: "Product consultation", value: 1 },
        { label: "Logistics services", value: 2 },
        { label: "Large order", value: 3 },
        { label: "Human service", value: 4 }],
      PresaleList: [
        { label: "Product consultation", value: 1 },
        { label: "Logistics services", value: 2 },
        { label: "Large order", value: 3 },
        { label: "Human service", value: 4 }],
      AftersaleList: [
        { label: "Order change", value: 5 },
        { label: "Logistics tracking", value: 6 },
        { label: "Payment", value: 7 },
        { label: "Product quality", value: 8 },
        { label: "Return goods", value: 9 },
        { label: "Large order", value: 3 },
        { label: "Human service", value: 4 },
      ],
      OrderListData: [],
      ProductListData: [],
      RecordingList: [],
      RecordingListParams: {
        pageIndex: 0,
        pageSize: 0,
        totalCount: 1,
        totalPages: 1,
        orderBy: "",
        sort: "",
        phoneNumber: ""
      },
      TimeZoneName:undefined,
      MemoTypeOptions: [
        { label: "Response required", value: 2 },
        { label: "No response needed", value: 1 },
        { label: 'Draft', value: 3 },
      ],
      Saveing:false,
      ToFormalLoading:false,
      labelWidth: {
        'width': '120px'
      },
      labelWidthTracking: {
        'width': '180px'
      },
      OrderInfoModel:{
        OrderForm: {
          sheets:[],
          number:0
        },
        MemoLoading:false,
        MemoType:'',
        DialogMemoVisible:false,
        MemoForm:{},
        MemoList:[],
        MemoPhone: '',
        MemoEmail: '',
        ContentType: undefined,
        ContentTypeText: '',
        CostwayCustomerGroup: '',
        orderUniqueId: 0,
        MemoNote: '',
        TrackingForm:{}
      },
      ProductInfoModel:{
        ProductForm:{
          cpbh:''
        },
        VideoUrl:'',
        InstructionsList:[],
        PickingList:[],
        PhotoList:[],
        PartsList:[],
        PartsImageList:[],
        FAQList:[]
      },
      AuthStoreOptions:[],
      upfilelist:[],
      MemoTabPaneTitle: 'Memo',
      MemoTabPaneStyle: {},
      ProductTagOptions:[],
      dialogAddrVisible: false,
      ChangeAddrForm: {},
      ChangeAddrLogList: [],
      IsModifiable: false,
      contentTypeOptions: [],
      memoRules: {
          contentType: [
              { required: true, message: 'required', trigger: 'change' }
          ],
      },
      dialogMemeKey: false,
      memoKeyForm: {
          MemoPhone: '',
          MemoEmail: '',
          MemoContentType: undefined,
          MemoNote: '',
          nid: 0,
          orderUniqueId:0,
      }
    }
  },

  mounted () {
    var url = window.location.href
    // var param = this.getParam(url, 'data')
    var phoneNum = this.getParam(url, 'phoneNum')
    var agentNum = this.getParam(url, 'agentNum')
    var inputValue = this.getParam(url, 'inputValue')
    var trackingNo = this.getParam(url, 'trackingNo')
    verify({ phoneNum: phoneNum, agentNum: agentNum,inputValue: inputValue, trackingNo: trackingNo }).then(res => {
      this.pageState = 9
      this.Recordform.phoneNumber = res.data.phoneNum
      this.RecordingListParams.phoneNumber = res.data.phoneNum
      this.OrderListParams.trackingNo = res.data.trackingNo
      this.OrderListParams.country = res.data.country
      this.Recordform.consultType = res.data.consultType
      this.TimeZoneName = res.data.timeZoneName
      this.changeConsultType(this.Recordform.consultType)
      this.Recordform.consult = res.data.consult
      if (!this.isEmpty(res.data.token)) {
        var token = res.data.token
        store.dispatch('setToken', token)
      }

      if (!this.isEmpty(this.OrderListParams.trackingNo)) {
        this.queryOrderList()
      }

      if (!this.isEmpty(this.RecordingListParams.phoneNumber)) {
        this.getRecordings()
      }
      this.doGetProductTagOptions()
      this.countryChangeEvent()

      GetContentTypeOptions().then(res=>{
        this.contentTypeOptions = res.data
      })
    }).catch(()=>{
        this.pageState = -1
      })

  },

  methods: {
    getParam (url, name) {
      try {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
        var r = url.split('?')[1].match(reg)
        if (r != null) {
          return r[2]
        }
        return ''
      } catch (e) {
        return ''
      }
    },
    resetOrderInfo() {
      this.OrderInfoModel = {
        OrderForm: {
          sheets:[],
          number:0
        },
        MemoType:'',
        MemoLoading:false,
        DialogMemoVisible:false,
        MemoForm:{
          nid: 0,
          memo: '',
          memoType: 2,
          phone: '',
          email: '',
          preMemo: false,
          contentType: undefined,
          orderUniqueId: 0
        },
        MemoList:[],
        MemoPhone: '',
        MemoEmail: '',
        ContentType: undefined,
        ContentTypeText: '',
        CostwayCustomerGroup: '',
        orderUniqueId: 0,
        MemoNote: '',
        TrackingForm:{},
      }
      this.ChangeAddrLogList = []
      this.MemoTabPaneStyle = {}
      this.MemoTabPaneTitle = 'Memo'
    },
    countryChangeEvent(){
      changeCountry(this.OrderListParams.country).then(res => {
          if(res.code==200){
            GetAuthStoreOptions(this.OrderListParams.country).then(res => {
              this.AuthStoreOptions = res.data
            })
          }
          
      })
    },
    doGetProductTagOptions(){
      GetProductTagOptions().then(res=>{
        this.ProductTagOptions = res.data
      })
    },
    getRecordings () {
      if (this.isEmpty(this.RecordingListParams.phoneNumber)) {
        return
      }
      queryRecording(this.RecordingListParams).then(res => {
        this.RecordingList = res.data.dataSource
        this.RecordingListParams.pageIndex = res.data.pageIndex
        this.RecordingListParams.pageSize = res.data.pageSize
        this.RecordingListParams.totalCount = res.data.totalCount
        this.RecordingListParams.totalPages = res.data.totalPages
        if (this.RecordingList.length > 0) {
          this.Recordform.customerName = this.RecordingList[0].customerName
          this.Recordform.customerPhone = this.RecordingList[0].customerPhone
        }
      })
    },
    defualtSelectFirstRowOrder() {
      if (this.OrderListData.length>0) {
          this.$refs.orderTable.setCurrentRow(this.OrderListData[0])
          this.selectOrderData(this.OrderListData[0])
        }
    },
    queryOrderList () {
      this.OrderQueryType = 'Search'
      this.OrderListParams.pageIndex = 1
      this.getOrderList()
    },
    getOrderList () {
      this.loading = true
      this.resetOrderInfo()
      QueryOrder(this.OrderListParams).then(res => {
        this.OrderListData = res.data.dataSource
        this.OrderListParams.pageIndex = res.data.pageIndex
        this.OrderListParams.pageSize = res.data.pageSize
        this.OrderListParams.totalCount = res.data.totalCount
        this.OrderListParams.totalPages = res.data.totalPages
        this.defualtSelectFirstRowOrder()
        this.loading = false
      })
    },
    handleOrderSizeChange () {
      if (this.OrderQueryType === 'Search') {
        this.getOrderList()
      }
    },
    selectOrderData (row) {
      let that = this;
      if(that.OrderInfoModel.OrderForm.number !==row.number){
        that.OrderInfoModel.OrderForm = row
        that.getMemoListMethod()
        GetTracking({ nid: that.OrderInfoModel.OrderForm.number }).then(res => {
          that.OrderInfoModel.TrackingForm = res.data
          if (!!that.OrderInfoModel.TrackingForm.nodeList && this.OrderInfoModel.TrackingForm.nodeList.length > 0) {
            that.OrderInfoModel.TrackingForm.nodeList[this.OrderInfoModel.TrackingForm.nodeList.length - 1].color = "#0bbd87"
          }
        })

        GetProductLabelsAsNid(that.OrderInfoModel.OrderForm.number).then(res => {
          var list = res.data
          if(list.length>0){
             list.forEach(x=>{
               var sheet = that.OrderInfoModel.OrderForm.sheets.find(a=>{
                return a.cpbh.toUpperCase()==x.itemNo
               })
               if(sheet !=null){
                sheet.tagItems = x.tagItems
                if(sheet.tagItems.length>1){
                  sheet.tagText = x.tagItems[0] + '(+)'
                }else
                {
                  sheet.tagText = x.tagItems[0]
                }
               }
             })
          }
          
        })

        that.doGetChangeAddrLogs()
      }
      
    },
    getMemoListMethod() {
      let that = this;
      that.MemoTabPaneStyle = {}
      that.MemoTabPaneTitle = 'Memo'
      if(that.OrderInfoModel.OrderForm.number!==0){
        that.OrderInfoModel.MemoLoading = true
        GetOrderUniqueId({ nid: that.OrderInfoModel.OrderForm.number, orderType: that.OrderInfoModel.OrderForm.orderType, state: that.OrderInfoModel.OrderForm.state }).then(res=>{
            that.OrderInfoModel.orderUniqueId = res.data
        })
        GetMemoInfo({ nid: that.OrderInfoModel.OrderForm.number }).then(res => {
          var data = res.data;
          that.OrderInfoModel.MemoList = data.items
          that.OrderInfoModel.MemoPhone = data.phone
          that.OrderInfoModel.MemoEmail = data.email
          that.OrderInfoModel.MemoLoading = false

          that.OrderInfoModel.MemoContentType = data.contentType
          if (that.OrderInfoModel.MemoContentType === 0) {
              that.OrderInfoModel.MemoContentType = undefined
          }
          that.OrderInfoModel.MemoContentTypeText = data.contentTypeText
          that.OrderInfoModel.MemoNote = data.note

          if (that.OrderInfoModel.MemoList.length > 0) {
            that.MemoTabPaneTitle = `Memo( ${that.OrderInfoModel.MemoList.length} )`
            that.MemoTabPaneStyle = { color: 'red', 'font-weight': 'bold' }

              if (!that.OrderInfoModel.MemoContentType) {
                that.OrderInfoModel.MemoContentType = 9
              }
          }
        })
      }

    },

    submitRecord () {
      autoSaveRecording(this.Recordform).then(res => {
        if (res.code === 200) {
          this.Recordform.id = res.data
          this.$message({
            message: 'Submitted successfully',
            type: 'success'
          })
          this.getRecordings()
        }
      })
    },
    changeConsultType (e) {
      if (e == 1)
        this.ConsultItem = this.PresaleList
      else
        this.ConsultItem = this.AftersaleList
      this.$set(this.Recordform, 'Consult', '')
      // eslint-disable-next-line
      this.$forceUpdate();
    },
    handleQueryProduct () {
      this.ProductSearchParams.tag = ''
      if(this.ProductSearchParams.tags&&this.ProductSearchParams.tags.length>0){
        this.ProductSearchParams.tag = this.ProductSearchParams.tags[this.ProductSearchParams.tags.length-1]
      }
      if (this.isEmpty(this.ProductSearchParams.cpbh)&&this.isEmpty(this.ProductSearchParams.tag)) {
        this.$message({
          message: 'Please enter a search term',
          type: 'warning'
        })
        return
      }
      this.ProductSearchParams.pageIndex = 1
      this.ProductInfoModel={
        ProductForm:{
          cpbh:''
        },
        VideoUrl:'',
        InstructionsList:[],
        PickingList:[],
        PhotoList:[],
        PartsList:[],
        PartsImageList:[],
        FAQList:[]
      }
      this.getProductList()
    },
    getProductList () {
      
      
      this.loading = true
      QueryProduct(this.ProductSearchParams).then(res => {
        if (res.code === 200) {
          this.ProductListData = res.data.dataSource
          this.ProductSearchParams.pageIndex = res.data.pageIndex
          this.ProductSearchParams.pageSize = res.data.pageSize
          this.ProductSearchParams.totalCount = res.data.totalCount
          this.ProductSearchParams.totalPages = res.data.totalPages
          if (this.ProductListData.length > 0) {
            this.$refs.productTable.setCurrentRow(this.ProductListData[0])
            this.selectProductData(this.ProductListData[0])
          }
          this.loading = false

          if(this.ProductListData.length>0){
            var items = this.ProductListData.map(e => {
                        return e.cpbh
                    })
            var data = { items:items}
            GetProductTags(data).then(res => {
              var list = res.data
              if(list.length>0){
                list.forEach(x=>{
                  var sheet = this.ProductListData.find(a=>{
                    return a.cpbh.toUpperCase()==x.itemNo
                  })
                  if(sheet !=null){
                    sheet.tagItems = x.tagItems
                    if(sheet.tagItems.length>1){
                      sheet.tagText = x.tagItems[0] + '(+)'
                    }else
                    {
                      sheet.tagText = x.tagItems[0]
                    }
                  }
                })
              }
              
            })
          }
        }
      })
      .catch(()=>{
        this.loading = false
      })
    },
    selectProductData (row) {
      if(this.ProductInfoModel.ProductForm.cpbh === row.cpbh) {
        return
      }
      this.ProductInfoModel.ProductForm = row
      GetInstallationVideo({productNo:row.cpbh}).then(res => {
        this.ProductInfoModel.VideoUrl = res.data
      })
      GetProductPhotoList(row.cpbh).then(res => {
        if (res.code === 200) {
          this.ProductInfoModel.PhotoList = res.data
        }
      })
      GetInstructions(row.cpbh).then(res => {
        if (res.code === 200) {
          this.ProductInfoModel.InstructionsList = res.data
        }
      })

      GetPackingList(row.cpbh).then(res => {
        if (res.code === 200) {
          this.ProductInfoModel.PickingList = res.data
        }
      })

      GetProductPartsList(row.cpbh).then(res => {
        if (res.code === 200) {
          this.ProductInfoModel.PartsList = res.data
          this.ProductInfoModel.PartsImageList = res.data.map(e => {
              return e.url
          })
        }
      })
      GetProductFAQList(row.cpbh).then(res => {
        if (res.code === 200) {
          this.ProductInfoModel.FAQList = res.data
        }
      })
    },
    isEmpty (value) {
      if (value === undefined || value === null || value === '') {
        return true
      }
      return false
    },
    deepClone (obj) {
      let _obj = JSON.stringify(obj)
      let objClone = JSON.parse(_obj)
      return objClone
    },
    ShowBigImage(url) {
      let that = this;
      
      that.$confirm(
          'Are you sure to download this file?',
          'Warning',
          {
              confirmButtonText: 'Ok',
              cancelButtonText: 'Cancel',
              type: 'warning'
          }
      )
          .then(() => {
              const a = document.createElement('a');
              a.target = '_black';
              a.href = url;
              a.click();
          })
          .catch(() => { })

      
    },
    ShowMemoForm(type, obj) {
      let that = this
      that.Saveing = false
      that.ToFormalLoading = false
      that.OrderInfoModel.MemoType = type;
      that.upfilelist = [];
      if (type == "Add") {
          that.OrderInfoModel.MemoForm = {
              nId: that.OrderInfoModel.OrderForm.number,
              memo: "",
              memoType: 2,
              phone: that.OrderInfoModel.MemoPhone,
              email: that.OrderInfoModel.MemoEmail,
              polylinkPhone: that.Recordform.phoneNumber,
              preMemo: false,
              contentType:that.OrderInfoModel.MemoContentType,
              orderUniqueId:that.OrderInfoModel.orderUniqueId,
          }
          if(obj){
            that.OrderInfoModel.MemoForm.preMemo = true;
          }
      }
      else {
          that.OrderInfoModel.MemoForm  = obj;
          if (obj.files) {
              that.upfilelist = obj.files;
          }
          that.OrderInfoModel.MemoForm.phone = that.OrderInfoModel.MemoPhone
          that.OrderInfoModel.MemoForm.email = that.OrderInfoModel.MemoEmail
          that.OrderInfoModel.MemoForm.orderUniqueId = that.OrderInfoModel.orderUniqueId
      }
      that.OrderInfoModel.DialogMemoVisible = true;
    },
    showMemoInfo(row) {
      this.ShowMemoForm("View", row)
    },
    replyEvent(){
       var obj = this.deepClone(this.OrderInfoModel.MemoForm);
       this.ShowMemoForm('Add',obj)
    },
    handleClose() {
      if (this.OrderInfoModel.MemoType == "View") {
          this.OrderInfoModel.DialogMemoVisible = false;
          return;
      }
      this.$confirm('Confirm to close？').then(e => {
        e;
          this.OrderInfoModel.DialogMemoVisible = false;
      })
      .catch()
    },
    setMemoFiles(){
      let that = this;
      if (that.upfilelist.length > 0) {
          var fileSuccessList = []
          that.upfilelist.forEach(t => {
              if (t && t.response) {
                  var path = t.response.data;
                  if (that.isEmpty(path)) {
                      that.Saveing = false;
                      that.$message.error('File upload failed, please remove the failed file');
                      return false;
                  }
                  fileSuccessList.push({ name: t.name, id: "", path: path })
              }
              else {
                  fileSuccessList.push({ name: t.name, id: t.id })
              }
          })
          that.OrderInfoModel.MemoForm.files = fileSuccessList;
      }
      return true;
    },
    SubmitMemoEvent() {
      let that = this;
      if(!that.setMemoFiles()){
        return;
      }
      this.$refs.MemoForm.validate((valid) => {
          if (valid) {
            that.Saveing = true;
            SubmitMemo(that.OrderInfoModel.MemoForm).then(res => {
              that.Saveing = false
              if (res.code === 200) {
                that.$message({
                  message: 'Submitted successfully',
                  type: 'success'
                })
                that.getMemoListMethod()
                that.OrderInfoModel.DialogMemoVisible = false;
              }
            })
          } else {
           that.$notify.error({
                title: 'Error',
                message: 'Please check the required fields'
            });
          }
        });

      
      
    },
    doUpdateMemo() {
      var that = this;
      if(!that.setMemoFiles()){
        return;
      }
      that.Saveing = true;
      
      UpdateMemo(that.OrderInfoModel.MemoForm).then(res => {
        that.Saveing = false
        if (res.code === 200) {
          that.$message({
            message: 'Submitted successfully',
            type: 'success'
          })
          that.getMemoListMethod()
          that.OrderInfoModel.DialogMemoVisible = false;
        }
      })
    },
    doDraftToFormal(){
      var that = this;
      if(!that.setMemoFiles()){
        return;
      }
      that.ToFormalLoading = true;
      SubmitMemoDraftToFormal(that.OrderInfoModel.MemoForm).then(res => {
        that.ToFormalLoading = false
        if (res.code === 200) {
          that.$message({
            message: 'Submitted successfully',
            type: 'success'
          })
          that.getMemoListMethod()
          that.OrderInfoModel.DialogMemoVisible = false;
        }
      })
    },
    doDeleteMemo(row) {
      var that = this;
      DeleteMemo(row.id).then(res => {
        if (res.code === 200) {
          that.$message({
            message: 'Delete successfully',
            type: 'success'
          })
          that.getMemoListMethod()
        }else{
          that.$message.error(res.message)
        }
      })
    },
    handleRemove(file, fileList) {
        this.upfilelist = []
        this.upfilelist = fileList
    },
    handleError(res) {
        this.$message.error(res);
    },
    handlePictureCardPreview(file) {
      if (file.downloadUrl) {
          this.ShowBigImage(file.downloadUrl)
      } else {
          this.ShowBigImage(file.url)
      }

    },
    formatDate(row, column) {
        // 获取单元格数据
        let data = row[column.property]
        if(data == null) {
            return null
        }
        let dt = new Date(data)
          return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate() 
    },
    doOpenAddrDialog() {
        var that = this
        that.ChangeAddrForm = {}
        that.dialogAddrVisible = true
        if (that.OrderInfoModel.OrderForm.number !==0) {
          GetTempChangeOrderAddrInfo(that.OrderInfoModel.OrderForm.number).then(res => {
            that.ChangeAddrForm = res.data
          })
        }
    },
    async doSubmitChangeAddr() {
        var that = this
        var submittable = true
        if (that.OrderInfoModel.OrderForm.number !==0) {
            if (that.ChangeAddrForm.changeAddrType === 1) { // 判断是否已进入打单流程
                await GetTempChangeOrderAddrInfo(that.OrderInfoModel.OrderForm.number).then(res => {
                  if (res.code === 200) {
                      if (res.data.changeAddrType === 2) { // 已进入打单流程
                          that.$notify({
                              title: 'Warning',
                              message: 'Entered the process of create label，need to charge for it',
                              type: 'warning'
                          });
                          that.ChangeAddrForm.changeAddrType = res.data.changeAddrType
                          that.ChangeAddrForm.commissionAmount = res.data.commissionAmount
                          that.ChangeAddrForm.currency = res.data.currency
                          that.ChangeAddrForm.logisticsType = res.data.logisticsType
                          submittable = false
                          return
                      }
                  } else {
                      that.$notify.error({
                          title: 'Error',
                          message: res.message
                      });
                      submittable = false
                      return
                  }
                })
            }
            if (submittable) {
                var postData = {
                    nid: that.ChangeAddrForm.nid,
                    address: that.ChangeAddrForm.address,
                    address1: that.ChangeAddrForm.address1,
                    city: that.ChangeAddrForm.city,
                    states: that.ChangeAddrForm.states,
                    zipcode: that.ChangeAddrForm.zipcode,
                }
                that.Saveing = true
                SubmitChangeAddr(postData).then(res => {
                  that.Saveing = false
                  if(res.code==200){
                    that.$message({
                      message: 'Submitted successfully',
                      type: 'success'
                    })
                    that.doGetChangeAddrLogs();
                    that.dialogAddrVisible = false
                  }
                  
                })
                
            }
        }
    },
    doGetChangeAddrLogs() {
        var that = this
        that.ChangeAddrLogList = []
        that.IsModifiable = false
        if (that.OrderInfoModel.OrderForm.number !==0 && !!that.OrderInfoModel.OrderForm.orderKey) {
            GetChangeAddrModifiable(that.OrderInfoModel.OrderForm.number).then(res => {
              that.IsModifiable = res.data
            })
            GetChangeAddrLog(that.OrderInfoModel.OrderForm.orderKey).then(res => {
              that.ChangeAddrLogList = res.data
            })
        }
    },
  }
}
</script>


<style scoped>
.main {
  background-color: #eee;
  width: 100%;
  height: 100%;
}

.main .box {
  height: 869px;
}
.title {
  display: inline-block;
  width: 120px;
  text-align: right;
  padding-right: 10px;
  font-weight: 700;
  vertical-align: top;
}
.content {
  display: inline-block;
  word-break: break-all;
}
.el-row {
  margin-bottom: 5px;
}
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}
.pre {
    white-space: pre-line !important;
    }
.el-form-item {
    margin-bottom: 10px !important;
}

</style>